module.exports = __webpack_public_path__ + "img/720.45c53c08.svg";